<script lang="ts">
    import { onMount } from 'svelte'
    import type { Channel } from '../../modules/brokerApi/channels/channel'
    import type { Creative } from '../../modules/brokerApi/creatives/creative'
    import ZContainer from '../_common/z/z-container.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import { AutomationSourceEnum } from '../../modules/automationApi/automations/automation-source.enum'
    import { DEFAULT_MESSAGES } from './default-messages'

    export let isEdit: boolean
    export let channels: Channel[]
    export let creatives: Creative[]
    export let creativeId: string
    export let message: string
    export let channelId: string
    export let act: string

    // Automação criada pelo assistente chega com automationId mas sem canal: para a escolha do
    // template ela ainda é nova. Só respeita o creativeId gravado quem já tinha canal ao abrir.
    let savedChannelId: string = null
    let loaded = false
    onMount(async () => {
        savedChannelId = channelId
        loaded = true
        onChannelChange()
    })

    let creativeOptions: { label: string; value: string }[] = []
    let selectedCreative: Creative = null
    function onChannelChange() {
        creativeOptions = []
        let selectedChannel = channels.find((el) => el.channelId === channelId)
        if (!selectedChannel) {
            return
        }
        const filtereds = creatives.filter((el) => selectedChannel.type.startsWith(el.service + '_'))
        for (const filtered of filtereds) {
            let label = filtered.label
            if (filtered.wabaCategory) label += ' (' + filtered.wabaCategory?.toLowerCase() + ')'
            creativeOptions.push({
                label,
                value: filtered.creativeId,
            })
        }
        creativeOptions = creativeOptions
        if (!isEdit || !savedChannelId) {
            creativeId = null
            if (act?.includes('automacao_nps_solicitar')) {
                creativeId = filtereds.find((el) => el.wabaName?.startsWith('zandu_default_nps_request'))?.creativeId || null
            }
            if (act?.includes('automacao_agenda_confirmar')) {
                const isReminder = message === DEFAULT_MESSAGES.lembrete.text
                const wabaName = isReminder ? DEFAULT_MESSAGES.lembrete.wabaName : DEFAULT_MESSAGES.confirmacao.wabaName
                creativeId = filtereds.find((el) => el.wabaName?.startsWith(wabaName))?.creativeId || null
            }
            if (act?.includes('automacao_indica_contactar')) {
                creativeId = filtereds.find((el) => el.wabaName?.startsWith('zandu_default_referral_first'))?.creativeId || null
            }
        }
        typeOptions = []
        typeOptions.push({ label: 'Enviar template', value: 'template' })
        if (!selectedChannel.type?.includes('waba')) {
            typeOptions.push({ label: 'Enviar mensagem', value: 'message' })
        }
        typeOptions = typeOptions
        if (creativeId) {
            type = 'template'
        } else {
            type = 'message'
        }

        onTypeChange()
        if (creativeId) onCreativeChange()
    }

    let typeOptions: { label: string; value: string }[] = []
    let channelOptions: { label: string; value: string }[] = []
    let type: 'message' | 'template'
    onMount(async () => {
        loadOptions()
    })

    function loadOptions() {
        channelOptions = []
        for (const channel of channels) {
            channelOptions.push({
                label: channel.label,
                value: channel.channelId,
            })
        }
        channelOptions = channelOptions
    }

    function onTypeChange() {
        if (type === 'message') creativeId = null // CRÍTICO: SE NÃO ANULAR SERÁ ENVIADO TEMPLATE PELA AUTOMATIONS-API
        updateSampleMessage()
    }

    function onCreativeChange() {
        selectedCreative = creatives.find((el) => el.creativeId === creativeId)
        updateSampleMessage()
    }

    let sampleMessage: string = ''
    function updateSampleMessage() {
        sampleMessage = ''
        if (selectedCreative?.wabaComponents?.length > 0) {
            const comp = selectedCreative.wabaComponents.find((el) => el.type === 'BODY')
            if (!comp) return
            sampleMessage = comp.text
            return
        }
        if (selectedCreative?.message) {
            sampleMessage = selectedCreative.message
            return
        }
        if (!message) {
            console.log('sample', act)
            if (act.startsWith('automacao_agenda')) {
                message = DEFAULT_MESSAGES.confirmacao.text
            }
            if (act.startsWith('automacao_nps')) {
                message =
                    'Oi {primeironome}. Poderia avaliar como foi sua experiência em seu último atendimento?\n\nPara avaliar basta clicar no link abaixo:\n{npslink}\n\nLeva menos de 10 segundos e nos ajuda muito!'
            }
            if (act.startsWith('automacao_indica')) {
                message = 'Olá {primeironome}. Quem me passou seu contato foi a {indicadorprimeironome}, tudo bem?'
            }
            if (act.startsWith('automacao_pdv')) {
                message = 'Olá. Agradecemos sua visita de hoje. Caso precisar estamos sempre à disposição.'
            }
        }
    }
</script>

{#if loaded}
    <ZContainer>
        <Zinput size={6} type="select" label="Selecione o provedor" options={channelOptions} bind:value={channelId} on:change={onChannelChange}></Zinput>
        <Zinput size={6} type="select" label="Tipo de mensagem" options={typeOptions} bind:value={type} on:change={onTypeChange}></Zinput>
        {#if type === 'template'}
            <Zinput size={12} type="select" label="Selecione o template" options={creativeOptions} bind:value={creativeId} on:change={onCreativeChange}
            ></Zinput>
            <Zinput disabled={true} size={12} type="textarea" rows={11} label="Mensagem do template" value={sampleMessage}></Zinput>
            {#if selectedCreative?.variables.length > 0}
                <Zinput disabled={true} size={12} type="text" label="Valores a serem atribuídos às variáveis {'{{}}'}" value={selectedCreative.variables}
                ></Zinput>
            {/if}
        {:else}
            <Zinput size={12} type="textarea" rows={13} label="Mensagem" bind:value={message}></Zinput>
        {/if}
    </ZContainer>
{/if}
